module.exports = __webpack_public_path__ + "img/SKMA_rules3.3bc94cc0.png";